export default __webpack_public_path__ + "static/media/trash.52674db5.svg";